import { createInputTokens } from '../tokens/components.js';
import { SEMANTIC, type SemanticTokens } from '../tokens/semantic.js';

/**
 * Inputtext Component Configuration
 */
export function createInputtext(s: SemanticTokens) {
  const inputTokens = createInputTokens(s);
  return {
    root: {
      background: inputTokens.bg,
      disabledBackground: inputTokens.bgDisabled,
      filledBackground: inputTokens.bg,
      filledHoverBackground: inputTokens.bgHover,
      filledFocusBackground: inputTokens.bg,
      borderColor: inputTokens.border,
      hoverBorderColor: inputTokens.border,
      focusBorderColor: inputTokens.borderFocus,
      invalidBorderColor: inputTokens.borderInvalid,
      color: inputTokens.fg,
      disabledColor: inputTokens.fgDisabled,
      placeholderColor: inputTokens.placeholder,
      invalidPlaceholderColor: inputTokens.placeholder,
      shadow: 'none',
      paddingX: inputTokens.base.paddingX,
      paddingY: inputTokens.base.paddingY,
      borderRadius: inputTokens.base.radius,
      focusRing: { width: '0', style: 'none', color: 'transparent', offset: '0', shadow: 'none' },
      transitionDuration: inputTokens.base.transition,
    },
    colorScheme: {
      light: {
        root: {
          background: inputTokens.bg,
          disabledBackground: inputTokens.bgDisabled,
          filledBackground: inputTokens.bg,
          filledHoverBackground: inputTokens.bgHover,
          filledFocusBackground: inputTokens.bg,
          borderColor: inputTokens.border,
          hoverBorderColor: inputTokens.border,
          focusBorderColor: inputTokens.borderFocus,
          invalidBorderColor: inputTokens.borderInvalid,
          color: inputTokens.fg,
          disabledColor: inputTokens.fgDisabled,
          placeholderColor: inputTokens.placeholder,
          invalidPlaceholderColor: inputTokens.placeholder,
        },
      },
    },
    css: () => `
      /* Normalize line-height to match p-multiselect (avoids 58px vs 56px discrepancy
         caused by inheriting body line-height: 1.5 from Tailwind) */
      .p-inputtext {
        line-height: normal;
      }

      .p-inputtext.nbx-filters-trigger {
        height: ${inputTokens.filtersTrigger.height};
        border: 0;
        outline: ${inputTokens.filtersTrigger.outlineWidth} solid ${inputTokens.border};
        outline-offset: calc(-1 * ${inputTokens.filtersTrigger.outlineWidth});
      }

      .p-inputtext.nbx-filters-trigger:enabled:focus {
        outline: ${inputTokens.filtersTrigger.outlineWidth} solid ${inputTokens.border};
        outline-offset: calc(-1 * ${inputTokens.filtersTrigger.outlineWidth});
      }

      .p-inputtext.nbx-filters-trigger:focus-visible {
        outline-color: ${inputTokens.borderFocus};
      }

      /* Read-only: legible like an enabled field, but set apart from the editable ones.
         A read-only input that is the face of a control (picker trigger, stepper) opts out
         with .nbx-control-input and keeps the editable look. */
      .p-inputtext[readonly]:not(:disabled):not(.nbx-control-input) {
        background: ${s.surface.canvas};
        border-color: ${s.border.divider};
      }

      /* Disabled placeholder color */
      .p-inputtext:disabled::placeholder {
        color: ${inputTokens.fgDisabled};
      }

      /* Disabled icon color in p-iconfield */
      .p-iconfield:has(.p-inputtext:disabled) .p-inputicon {
        color: ${inputTokens.fgDisabled};
      }
    `,
  };
}
export const inputtext = createInputtext(SEMANTIC);
